import DaAppContainer from './DaApp.container';
import DaApp from './DaApp';
export default DaAppContainer(DaApp);
export { default as DaAppWrapper } from './DaAppWrapper';
//# sourceMappingURL=index.js.map